import type { Form } from 'app/routes/Admin/Contracts/interfaces';
import type { CsvParseResponse } from 'app/routes/Admin/Users/interfaces';
import { http } from 'config';
import {
  type ContractOutput as Contract,
  type PowerCategory,
  type UserGroup,
  type UserGroupList,
  type UserGroupWithKind,
} from 'types/swagger';

import {
  CONTRACTS_BY_ID_URL,
  CONTRACTS_URL,
  POWER_CATEGORY_URL,
  USER_GROUPS_BY_ID_URL,
  USER_GROUPS_PARSE_CSV_BY_ID_URL,
  USER_GROUPS_URL,
  WHITE_LABEL_VARIABLES_URL,
} from './endpoints';

export const getContracts = async (pageSize = 999) =>
  await http.get<{ results: Contract[] }>(CONTRACTS_URL, {
    params: { page_size: pageSize },
  });

export const createUserGroup = async (
  newUserGroup: Pick<UserGroupWithKind, 'name' | 'user_group_kind'> &
    Partial<Pick<UserGroupWithKind, 'profiles'>>
) => await http.post<UserGroupWithKind>(USER_GROUPS_URL, newUserGroup);

export const getUserGroups = async (pageSize = 999) =>
  await http.get<UserGroupList>(USER_GROUPS_URL, {
    params: { page_size: pageSize },
  });

export const getUserGroupById = async (id: number) =>
  await http.get<UserGroup>(USER_GROUPS_BY_ID_URL(id));

export const updateUserGroup = async (id: number, data: { name: string }) =>
  await http.patch(USER_GROUPS_BY_ID_URL(id), data);

export const removeUserGroup = async (id: number) => await http.delete(USER_GROUPS_BY_ID_URL(id));

export const postUserGroupCsv = async (id: number, data: FormData) =>
  await http.post<CsvParseResponse>(USER_GROUPS_PARSE_CSV_BY_ID_URL(id), data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getPowerCategory = async () =>
  await http.get<{ results: PowerCategory[] }>(POWER_CATEGORY_URL);

export const createContract = async (data: Form) => await http.post(CONTRACTS_URL, data);

export const updateContract = async (id: number, data: Form) =>
  await http.patch(CONTRACTS_BY_ID_URL(id), data);

export const deleteContract = async (id: number) => await http.delete(CONTRACTS_BY_ID_URL(id));

export const getWhiteLabelVariables = async () => await http.get(WHITE_LABEL_VARIABLES_URL);
